export function openFile(src: string, fileName: string) {
  const a = document.createElement('a');
  a.href = src;
  a.target = '_blank';
  a.click();
}
